import isEqual from "lodash/isEqual";
export function getFilterData(
  {
    q = "",
    plzStart,
    plzEnd,
    startNumber,
    endNumber,
    branchSelect,
    city,
    eventSelect,
    filter_events_only,
  },
  offset
) {
  const result = [{ id: "oob", option: "eq", value: false }];
  const newQuery = q
    .replace("-", " ")
    .replace("_", " ")
    .replace("'", " ")
    .replace('"', " ");

  if (plzStart) {
    result.push({
      id: "co_zip",
      option: "gte",
      value: plzStart,
    });
  }
  if (plzEnd) {
    result.push({
      id: "co_zip",
      option: "lte",
      value: plzEnd,
    });
  }
  if (city) {
    const cityVal = city.charAt(0).toUpperCase() + city.slice(1);
    result.push({ id: "co_city", option: "contains", value: cityVal });
  }
  if (startNumber) {
    result.push({ id: "employees", option: "gte", value: startNumber });
  }
  if (endNumber) {
    result.push({ id: "employees", option: "lte", value: endNumber });
  }

  if (eventSelect && eventSelect.length > 0) {
    result.push({
      id: "event_type",
      option: "eq",
      value: eventSelect[0].value,
    });
  }

  if (!filter_events_only && !branchSelect) {
    return {
      type: "company",
      q: `${newQuery}*`,
      limit: parseInt(process.env.REACT_APP_SEARCH_LIMIT),
      filter: [result],
      offset: offset,
      sort: [{ id: "co_zip", order: "asc" }],
    };
  }

  if (!filter_events_only) {
    return {
      type: "company",
      sort: [{ id: "co_zip", order: "asc" }],
      offset: offset,
      limit: parseInt(process.env.REACT_APP_SEARCH_LIMIT),
      q: `${newQuery}*`,
      filter: branchSelect.length
        ? branchSelect.map(({ label }) => [
            ...result,
            {
              id: "company_wz2008",
              option: "contains",
              value: label,
            },
          ])
        : [result],
    };
  }
  const existingEventsFilter = [
    [{ id: "event_type", option: "eq", value: "inso_new" }, ...result],
    [{ id: "event_type", option: "eq", value: "sh_change" }, ...result],
    [{ id: "event_type", option: "eq", value: "ceo_change" }, ...result],
    [{ id: "event_type", option: "eq", value: "co_anni" }, ...result],
    [{ id: "event_type", option: "eq", value: "co_move" }, ...result],
    [{ id: "event_type", option: "eq", value: "co_new" }, ...result],
    [{ id: "event_type", option: "eq", value: "trainee_job_offer" }, ...result],
    [{ id: "event_type", option: "eq", value: "trainee_company" }, ...result],
    [{ id: "event_type", option: "eq", value: "job_offer" }, ...result],
    [{ id: "event_type", option: "eq", value: "co_change" }, ...result],
  ];

  if (!branchSelect || !branchSelect.length) {
    return {
      type: "company",
      offset: offset,
      limit: parseInt(process.env.REACT_APP_SEARCH_LIMIT),
      q: `${newQuery}*`,
      sort: [{ id: "co_zip", order: "asc" }],
      filter: existingEventsFilter,
    };
  }

  let filter = [];
  existingEventsFilter.forEach(f => {
    branchSelect.forEach(({ label }) => {
      filter.push([
        ...f,
        {
          id: "company_wz2008",
          option: "contains",
          value: label,
        },
      ]);
    });
  });
  return {
    type: "company",
    offset: offset,
    limit: parseInt(process.env.REACT_APP_SEARCH_LIMIT),
    q: `${newQuery}*`,
    sort: [{ id: "co_zip", order: "asc" }],
    filter,
  };
}

function cleanUpBeforeCompare(object) {
  return Object.keys(object).reduce((prev, curr) => {
    if (curr === "filter_name") {
      return prev;
    }
    if (object[curr]) {
      return { ...prev, [curr]: object[curr] };
    }
    return prev;
  }, {});
}
export function checkFiltersSimilarity(currFilters, selectedFilter) {
  return isEqual(cleanUpBeforeCompare(currFilters), cleanUpBeforeCompare(selectedFilter));
}
